// extracted by mini-css-extract-plugin
export default {"container":"edit-modal_container__TyWA2","modal":"edit-modal_modal__3sJZN","update-button":"edit-modal_update-button__5v3uK"};